module.exports = __webpack_public_path__ + "static/media/WebPokerThai.54ae4b08.webm";